import { getTheBoolean, select } from './utils'

const getLoan = state => state.loan
const selectFromLoan = select(getLoan)

export const selectLoanEditing = selectFromLoan(getTheBoolean('editing'))
export const selectLoanEditingBalance = selectFromLoan(
  getTheBoolean('editingBalance')
)
